import { graphql } from 'gatsby'
import React from 'react'

type DiplomaProps = {
  _template: string
  css_class_name: string
  settings: {
    css_class_name: "",
    custom_css: "",
    margin_bottom: "Medium"
  }
  variant: string
  title: string
  text: string
  cta_text: string
  cta_url: string
  image: string
  image_alt_text: string
}

const Diploma: React.FC<{ block: DiplomaProps }> = ({ block }) => {
  const variant =
    block.variant && block.variant !== 'Full Width'
      ? ` ${block._template}--${block.variant.toLowerCase()}`
      : ''

  return (
    <section
      className={`block ${block._template} ${block.css_class_name} ${variant}`}
    >
      <div className="container">
        <div className="block-diploma">
          <h2 className="block-diploma__title" dangerouslySetInnerHTML={{__html: block.title}} />
          <p className="block-diploma__text">{block.text}</p>
          <a className="cta cta-primary block-diploma__cta" href={block.cta_url}>
            {block.cta_text}
          </a>
          <img
            className="block-diploma__image"
            src={block.image}
            alt={block.image_alt_text}
          />
        </div>
      </div>
    </section>
  )
}

export const diplomaFragment = graphql`
  fragment DiplomaFragment on Block {
    variant
  }
`

export default Diploma
